"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generate = void 0;
const defaultNameArchive_1 = require("./defaultNameArchive");
const pickRandomGender_1 = require("./utils/pickRandomGender");
const pickRandomRace_1 = require("./utils/pickRandomRace");
const randomPick_1 = require("./utils/randomPick");
function generate({ gender: givenGender, race: givenRace } = {
    gender: null,
    race: null,
}) {
    const gender = givenGender !== null && givenGender !== void 0 ? givenGender : pickRandomGender_1.pickRandomGender();
    const race = givenRace !== null && givenRace !== void 0 ? givenRace : pickRandomRace_1.pickRandomRace();
    const perRaceArchive = defaultNameArchive_1.defaultNameArchive[race];
    const firstNamesByGender = perRaceArchive.first[gender];
    const firstName = randomPick_1.randomPick(firstNamesByGender);
    const lastName = randomPick_1.randomPick(perRaceArchive.last);
    return { gender, race, firstName, lastName };
}
exports.generate = generate;
//# sourceMappingURL=generate.js.map